export class IndividualizationDialogModel {
    public constructor(
        public header: string,
        public title1: string,
        public title2: string,
        public description: string,
        public save: string,
        public cancel: string,
    ) {}
}

export interface individualizationDialogResults {
    materialNumber: string;
    serialNumber: string;
    description: string;
}

export enum IndividualizationControlName {
    MATERIAL_NUMBER = 'materialNumber',
    SERIAL_NUMBER = 'serialNumber',
    DESCRIPTION = 'description',
}

export interface MaterialNumberDescription {
    materialDescription: string;
    materialNumber: string;
}
